(function($)
{

  $(document).ready( function()
  {
    document.addEventListener('click', e => {
      const dropdown = e.target.matches('[data-location-dropdown]');
      if (!dropdown && e.target.closest('[data-location-dropdown]') != null) return;

      let currentDrop;
      if (dropdown) {
        currentDrop = e.target.closest('[data-location-dropdown]');
        currentDrop.classList.toggle('active');
      }

      document.querySelectorAll('[data-location-dropdown].active').forEach(drop => {
        if (drop === currentDrop) return;
        drop.classList.remove('active');
      });
    });

  });


})( jQuery );
